import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'
import reducers from './reducers/persistedReducer'
import { composeWithDevTools } from 'redux-devtools-extension';
import api from '../lib/app-api';
import routes from './routes'
import { doGetChannels } from './actions/channels';
import ClusterMessages from '../lib/ClusterMessages';
import TitleSetter from '../utils/TitleSetter'
import { doGetFavoriteCells, doRefreshToken, doLogoutUser, USER_ACTIONS } from './actions/user';
import { selectChannelIds, selectIsUserGuest, selectToken } from './selectors';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import { CHANNEL_SETTINGS_ACTIONS } from './actions/channelSettings';
import { tokenTimeToExp, getJwtTokenPayload, isNative} from '../utils/utils';
import firebase from '../lib/firebase';

// const logger = (store: any) => (next: any) => (action: any) => {
//   console.log('dispatching', action)
//   let result = next(action)
//   return result
// }

// Create redux middleware. Containes middleware from Routes Thunk, and ReduxStateSync.
// The thunk middleware gets passed our API so that our redux actions have access to it.
const middlewares = composeWithDevTools(
  applyMiddleware(
    routes.middleware,
    thunk.withExtraArgument(api),
    createStateSyncMiddleware({
      whitelist: [...Object.values(USER_ACTIONS), CHANNEL_SETTINGS_ACTIONS.CHANGE_SETTING]
    }),
  ),
);

// Enhances our middleware with routes enhancers. No idea.
const enhancers = compose(routes.enhancer, middlewares);

// Generate our redux store.
const store = createStore(
  reducers,
  enhancers,
)

// Instantiate messaging service.
export const ClusterMessagesClient = new ClusterMessages(store);

// Post rehydration function.
const postRehydrate = async () => {
    // Start AppListeners
  if (isNative()) {
    import('../lib/CapacitorAppListeners').then(module => {
      module.default()
    })
  }

  let state = store.getState();
  const { dispatch }: any = store;
  const userIsGuest = selectIsUserGuest(state)

  // We set our API token if it exists in the rehydrated store.
  if (state.user.token !== '' && (userIsGuest || typeof state.user.authSourceToken !== "undefined")) {

    // Unlock refreshing token if stuck.
    if (state.user.tokenRefreshLocked) {
      dispatch({
        type: USER_ACTIONS.TOKEN_REFRESH_UNLOCKED
      });
    }

    try {
      // Auth token is or almost is expired.
      if (tokenTimeToExp(selectToken(state)) < 300) {
        await dispatch(doRefreshToken(userIsGuest, state.user.authSourceToken));
      } else {
        api.setToken(state.user.token);
      }

      // Sets the userid and auth source after rehydrating site. If the token is refreshed, it will still have the old auth_src.
      firebase.analytics.setUserId((state.user.user?.id!).toString());
      firebase.analytics.setUserProperties({auth_src: getJwtTokenPayload(state.user.token).authSrc});

      // Refresh our channel list.
      await dispatch(doGetChannels());

      // Update favorite cells
      dispatch(doGetFavoriteCells());

      // Connect to messaging service and subscribe to alerts
      ClusterMessagesClient.connect((client) => {
        client.subscribe("alerts", selectChannelIds(state));
      });
    } catch (error) {
      dispatch(doLogoutUser("Your session has expired."));
    }
  }

  // Fire off initial route dispatch after rehydration.
  if (routes.initialDispatch) {
    routes.initialDispatch();
  }
}

// Instatiate our store persistor. Call rehydration callback.
export const persistor = persistStore(store,null,postRehydrate);

// Runs title setter listener
TitleSetter(store);

//Passes store.dispatch to the message listener.
initMessageListener(store);

export default store;